import { render, staticRenderFns } from "./PRichTextEditor.vue?vue&type=template&id=790b2cf4"
import script from "./PRichTextEditor.vue?vue&type=script&lang=js"
export * from "./PRichTextEditor.vue?vue&type=script&lang=js"
import style0 from "./PRichTextEditor.vue?vue&type=style&index=0&id=790b2cf4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports